export function getQueryStringParameter(name) {
  const params = new URLSearchParams(window.location.search)
  return params.get(name) || '' // Return an empty string if the parameter is not found
}
